import CompositeLeafNodeBase from '../../../../framework/oop/composite/CompositeLeafNodeBase';
import DatasetTreeNode from '../logical/DatasetTreeNode';

import DatasetsLayoutNode from './DatasetsLayoutNode';
import DatasetsLayoutNodeVisitor from './DatasetsLayoutNodeVisitor';

/**
 * An element of a layout elements tree which contains a single dataset.
 */
class SingleDatasetLayoutNode
  extends CompositeLeafNodeBase<DatasetsLayoutNode>
  implements DatasetsLayoutNode
{
  /**
   * @param dataset - Associated logical dataset tree item.
   */
  constructor(private dataset: DatasetTreeNode) {
    super();
  }

  /**
   * Returns the associated dataset object.
   */
  public getDataset(): DatasetTreeNode {
    return this.dataset;
  }

  public acceptVisitor(visitor: DatasetsLayoutNodeVisitor): void {
    visitor.visitSingleDataset(this);
  }
}

export default SingleDatasetLayoutNode;
